module.exports = __webpack_public_path__ + "img/2025040709371372zx6.51c659b0.jpg";